module.exports = __webpack_public_path__ + "static/media/ge-group.9b775e6c.jpg";